"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignerTrayUsageType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var AlignerTrayUsageType_Factory = /** @class */ (function () {
    function AlignerTrayUsageType_Factory() {
    }
    AlignerTrayUsageType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    AlignerTrayUsageType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return AlignerTrayUsageType_Factory;
}());
exports.AlignerTrayUsageType_Factory = AlignerTrayUsageType_Factory;
